module.exports = __webpack_public_path__ + "img/mid.bb123343.png";